import { WorkbenchProvider } from '@gusto/workbench';
import { Route, Routes, BrowserRouter } from 'react-router-dom';
import NoMatch from 'helpers/no_match';
import Layout from './components/layout';
import PartnerForm from './components/partner_form';

export default function App({ domains }: { domains: string[] }) {
  return (
    <BrowserRouter basename="/partners/signup">
      <WorkbenchProvider>
        <Routes>
          <Route path="/" element={<Layout />}>
            <Route path="/form" element={<PartnerForm ssoDomains={domains} />} />
            <Route path="*" element={<NoMatch packageName="PartnerSignup" />} />
          </Route>
        </Routes>
      </WorkbenchProvider>
    </BrowserRouter>
  );
}
